import { keys, reduce, isNil } from 'lodash';
import { IError } from '@utils/useForm';
import { DeclarationForm } from '@models/DPI/Declaration.model';


export const validate = (values: DeclarationForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'policy':
    case 'summary':
    case 'term':
    case 'ped':
    case 'benefit':
    case 'assured':
    case 'completed':
    case 'understand':
    case 'completedDPI':
    case 'usedEstimator':
    case 'usedBudgetCalculator':
    case 'visitedCompareFirst':
    case 'considerDiffDPI':
      if (isNil(value) || value === false) {
        error = {isValid: false};
      }
      break;
  }
  return error;
}